import { Permission } from '@dispatch/shared/types';
import axios from 'axios';

const AUTHORIZATION_PERMISSION_URL = `dispatch/auth/permissions`;

export async function getPermissions() {
  return axios.get<Permission[]>(`${AUTHORIZATION_PERMISSION_URL}`);
}

export async function getPermission(permissionId: string) {
  return axios.get<Permission>(
    `${AUTHORIZATION_PERMISSION_URL}/${permissionId}`
  );
}

export async function upsertPermission(
  postData: Permission[],
  permissionId?: string
) {
  const id = permissionId ? `/${permissionId}` : '';
  return axios.put<Permission>(`${AUTHORIZATION_PERMISSION_URL}${id}`, [
    ...postData,
  ]);
}
